import { HeatMapZone, PointIndex } from 'logic/reports/HeatMapZone';
import { consts } from './drawZonesOnCanvas';
import { DrawData } from 'ui/shared/calculateDrawData';

export type Hit = 'zone' | 'handle' | 'name';
export type HitTestResult = null | {
    hit: Hit;
    zone: HeatMapZone;
    dragHandle?: PointIndex;
};

export const hitTestZones = (x: number, y: number, canvas: HTMLCanvasElement, drawData: DrawData, zones: ReadonlyArray<HeatMapZone>): HitTestResult => {
    const ctx = canvas.getContext('2d');
    if (!ctx) {
        return null;
    }
    ctx.save();

    ctx.font = `${consts.fontSize}px Arial`;
    
    const result = zones.map(zone => {
        const [ topLeft, topRight, bottomLeft, bottomRight ] = zone.points;
        
        // Test the drag handles
        const offset = (consts.dragHandleSize - 1) / 2;
        for (let i = 0; i < 4; i++) {
            ctx.beginPath();
            ctx.rect(zone.points[i].x - offset, zone.points[i].y - offset, consts.dragHandleSize, consts.dragHandleSize);
            if (ctx.isPointInPath(x, y)) {
                return { zone, hit: 'handle', dragHandle: i } as HitTestResult;
            }
        }

        // Test the zone name
        const nameSize = ctx.measureText(zone.name);
        ctx.beginPath();
        ctx.rect(topLeft.x + consts.xNameOffset,
            topLeft.y + consts.yNameOffset,
            nameSize.width + consts.xNamePadding * 2,
            consts.fontSize + consts.yNamePadding * 2
        );
        if (ctx.isPointInPath(x, y)) {
            return { zone, hit: 'name' } as HitTestResult;
        }

        // Test the zone body
        ctx.beginPath();
        ctx.moveTo(topLeft.x, topLeft.y);
        ctx.lineTo(topRight.x, topRight.y);
        ctx.lineTo(bottomRight.x, bottomRight.y);
        ctx.lineTo(bottomLeft.x, bottomLeft.y);
        ctx.closePath();
        if (ctx.isPointInPath(x, y)) {
            return { zone, hit: 'zone' } as HitTestResult;
        }

        return null;
    }).filter(ht => !!ht).shift() || null;

    ctx.restore();

    return result;
};



// WEBPACK FOOTER //
// ./src/ui/pages/designer/sections/zoneSelection/hitTestZones.ts